import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const Reviews = () => {
  const [rating, setRating] = useState('');
  const [remarks, setRemarks] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  const [couponsData, setCouponsData] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  // When user clicks "Add Review" for a coupon
  const selectCoupon = (coupon) => {
    setSelectedCoupon(coupon);
    setRemarks(''); // reset remarks for new coupon
    setRating('');
  };

  // Load user details from localStorage
  useEffect(() => {
  const googleLogin = localStorage.getItem('googleLogin');
  // console.log(googleLogin)

  if (googleLogin == 'false') {
    const data = localStorage.getItem('userLogin');
    if (data) setUserDetails(JSON.parse(data));
    // console.log(data);
  } else {
    const data = localStorage.getItem('userDashboardLogin');
    if (data) setUserDetails(JSON.parse(data));
    // console.log(data);
  }
}, []);


  // Fetch all coupons
  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/AdSlot/get-all-ad-slots')
      .then((res) => {setCouponsData(res.data)
        // console.log(res.data)
      })
      .catch((err) => console.log(err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedCoupon || !userDetails) {
      alert('Please select a coupon and ensure you are logged in.');
      return;
    }

    // Prepare payload exactly as backend expects
    const payload = {
      userId: userDetails.userId,
      couponId: selectedCoupon.couponId,
      merchantId: selectedCoupon.merchantId,
      rating: parseInt(rating),
      review: remarks,
      purchaseType: "offline",        
      purchaseAmount: 0,              
      purchaseDate: new Date().toISOString(),
      remarks: remarks,
      couponName: selectedCoupon.couponName
    };

    try {
      const response = await axios.post(
        'https://api.bakpoket.com/api/AToZ/submit-rating',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );
      alert('Rating submitted successfully!');
      // console.log('Submitted payload:', payload);

      // Reset form
      setRating('');
      setRemarks('');
      setSelectedCoupon(null);
    } catch (error) {
      console.error('Error submitting rating:', error.response?.data || error);
      alert('Something went wrong!');
    }
  };

  return (
    <div className='d-flex flex-column'>
      <Card>
        <h2 className='text-center'>Submit Review & Rating</h2>
        {selectedCoupon && <h3>Coupon Name: {selectedCoupon.couponName}</h3>}

        <form onSubmit={handleSubmit}>
          <input
            type='number'
            placeholder='Rating (1 to 5)'
            value={rating}
            min='1'
            max='5'
            onChange={(e) => setRating(e.target.value)}
            required
          />
          <textarea
            placeholder='Write your remarks'
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            required
          />
          <button type='submit'>Submit</button>
        </form>

        {/* Coupon List Header */}
        <div className='d-flex border table mt-2 mb-0'>
          <small className='p-2 me-auto'>Coupon Name</small>
          <small className='p-2 border-start'>Add Review</small>
        </div>

        {/* Coupons List */}
        <div className='body-coupons'>
          {couponsData.map((coupon, index) => (
            <div key={index} className='d-flex border table mb-0'>
              <small className='p-2 me-auto'>{coupon.couponName}</small>
              <small
                className='p-2 border-start'
                style={{ cursor: 'pointer', color: '#ef4766' }}
                onClick={() => selectCoupon(coupon)}
              >
                Add Review
              </small>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Reviews;

// Styled component
const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;

  .body-coupons {
    overflow-y: auto;
    max-height: 200px;
  }

  .body-coupons::-webkit-scrollbar {
    width: 0px;
  }

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }
  h3 {
    font-size: 15px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 300px;
    padding: 10px;

    h2 {
      font-size: 13px;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 13px;
      margin-bottom: 10px;
    }

    button {
      font-size: 10px;
      padding: 8px 12px;
    }
  }
`;



